<div class="padding">
  <h1 class="left-box">{{ 'common.labels.systemEvents' | transloco }}</h1>
  <mat-card>
    <mat-card-content>
      <app-system-events-history-filter></app-system-events-history-filter>
      <div class="table-container padding-top">
        <table mat-table matSort [dataSource]="this.repo.resource$" multiTemplateDataRows
          class="mat-elevation-z0" (matSortChange)="sort($event)"
          [class.table-loading]="this.repo.loading$ | async">

          <!-- Event Type -->
          <ng-container matColumnDef="systemEventTypeID">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.eventType' | transloco }} </th>
            <td mat-cell *matCellDef="let sysEvent"> {{ sysEvent.systemEventType.id | enumLabel:'systemEventType':sysEvent.systemEventType.name }} </td>
          </ng-container>

          <!-- Message -->
          <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.message' | transloco }} </th>
            <td mat-cell *matCellDef="let sysEvent"> {{sysEvent.message}} </td>
          </ng-container>

          <!-- Start Date -->
          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.start' | transloco }} </th>
            <td mat-cell *matCellDef="let sysEvent"> {{sysEvent.startDate | utcToLocalDate}} </td>
          </ng-container>

          <!-- End Date -->
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.end' | transloco }} </th>
            <td mat-cell *matCellDef="let sysEvent"> {{sysEvent.endDate | utcToLocalDate}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>
        </table>
      </div>
    </mat-card-content>
    @if ((this.repo.resourceCount$ | async) ?? 0 > 0) {
      <mat-paginator
        [pageSize]="this.repo.pageSize$ | async"
        [length]="this.repo.resourceCount$ | async"
        [pageIndex]="this.repo.pageNum$ | async"
        [pageSizeOptions]="[10, 25, 50]"
      (page)="page($event)"></mat-paginator>
    }
  </mat-card>
</div>